export default __webpack_public_path__ + "src/assets/unidai.f91a70b889bb0bfe33eb405ee2fd9e49.svg";